import React from 'react';
import { BodyText, FlexRow, SvgIcon } from '@make-software/cspr-ui';
import styled from 'styled-components';
import ImportantIcon from 'assets/icons/ic-info-important.svg';

const StyledWarningWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    backgroundColor: '#FDF5DACC',
    padding: '16px'
  })
);

const StyledSvg = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    marginRight: '8px'
  })
);

interface WarningWindowProps {
  message: string | React.ReactElement;
}

export const WarningWindow = ({ message }: WarningWindowProps) => {
  return (
    <>
      <StyledWarningWrapper align={'center'}>
        <StyledSvg src={ImportantIcon} color={'yellow'} />
        <BodyText size={2} scale={'xs'}>
          {message}
        </BodyText>
      </StyledWarningWrapper>
    </>
  );
};
